
import { Component, Vue, Watch } from "vue-property-decorator";
import { RankingList, StatisticalData, deviceStatus } from "@/views/components";
import deviceItem from "@/views/components/DeviceStatus/deviceItem";
import YtoTable from "@/views/components/YtoTable/TtoTable.vue";
import Scan from "@/views/components/Scan/Scan.vue";
import config from "./config";
import Form1 from "./Form1.vue";
import Form2 from "./Form2.vue";
import TableHeader from "./TableHeader.vue";
import { ApiQueryType, ModeType } from "@/common/glboalconstant";
import {
  getOrgCodeListByPage,
  // checklineFrequencys,
  checkCodesAndType,
  faCheGetNextOrgCodeByCQ,
} from "@/api/service";
import {
  playSuccessSound,
  playFailSound,
  NoticeVoiceInit,
} from "@/common/voiceTip";
import dayjs from "dayjs";
import { LogHelper } from "@/common/LogHelper";
import {
  checkCode,
  toolsRegularCheckCode,
  getCqNoByCpNo,
  truckOperation,
  getLineListByPage,
} from "@/api/service";
import { CarContainerStatus } from "@/api/serviceHelper";
import { ScanforDepartModule } from "@/store/modules/store_scanfordepart";
import { SystemConfigModule } from "@/store/modules/store_systemconfig";

@Component({
  name: "scanfordepartcar",
  components: {
    deviceStatus,
    RankingList,
    StatisticalData,
    YtoTable,
    Form1,
    Form2,
    TableHeader,
    Scan,
  },
})
export default class extends Vue {
  private inputModel: inputDataModel_Depart = {
    checked_NextOrgCode: false,
    input_ScanCode: "",
    input_CarSignNum: "",
    input_LineNo: "",
    input_LineName: "",
    input_NextOrgCode: "",
    input_OrgName: "",
    checked_OverTimeCar: false,
    options_NextOrg: [],
  };
  public globalConfig: any = {};
  public systemConfig: any = {};
  public loginData: any = {};
  public nTotalScanNum = 0;

  mounted() {
    try {
      this.ErrorMessage = "";
      this.globalConfig = SystemConfigModule.globalData;
      this.systemConfig = SystemConfigModule.systemData;
      this.loginData = SystemConfigModule.loginData;
    } catch (error) {
      console.log("发车界面:注册回调函数异常" + error);
    }
    var el = document.getElementById("input_scancode_id");
    this.selectElementContents(el);
  }

  get ErrorMessage() {
    return ScanforDepartModule.errorMessage;
  }
  set ErrorMessage(str) {
    ScanforDepartModule.setErrorMessage(str);
  }

  private getFormValue(element) {
    this.inputModel = element;
  }
  private currentRowChanged(element) {
    this.currentrow = element;
  }

  public index = 1;
  public totalScanCount = "0";

  public msg = "";
  private config = config;
  // private statisticalList = [];
  public currentrow = null;
  public showList = [];
  public ytoCode = "";
  //扫描区扫码
  private ytocodeget() {
    this.inputModel.input_ScanCode = this.ytoCode.toUpperCase();
    try {
      var scanAreaContent = this.inputModel.input_ScanCode.toUpperCase().trim();
      if (scanAreaContent == "") {
        try {
          playFailSound();
          this.ErrorMessage = "输入为空";
          return;
        } catch (Exception) {
          this.ErrorMessage = "输入为空,警告提示音不存在";
          return;
        }
      }

      let reg1 = new RegExp(/^[A-Za-z0-9]+$/);
      if (!reg1.test(scanAreaContent)) {
        this.ErrorMessage = "输入数据非法，只能输入数字和字母";
        return;
      }
      this.ErrorMessage = "";

      let bReturnState = true;

      try {
        let stCodeCheckInput: any = {
          devMac: this.globalConfig.LocalMac,
          devType: "0",
          body: {
            queryValue: scanAreaContent,
            queryType: "0",
            viewType: "1",
            extend1: "",
            extend2: "",
            extend3: "",
          },
        };
        //先本地
        let stReturnData = this.CheckCode(stCodeCheckInput);
        this.ErrorMessage = stReturnData.respMessage;
        LogHelper.WriteLog(stReturnData);
        if (stReturnData.respcode != "000") {
          try {
            // // ToolsPlayVoice.CreateSingleInstance().PlayAsycSound(strOperFailVoice);
            playFailSound();
          } catch (Exception) {
            this.ErrorMessage = "失败提示音不存在";
          }

          bReturnState = false;
          if (
            stReturnData.respMessage == "" ||
            stReturnData.respMessage == null ||
            stReturnData.respMessage == undefined
          ) {
            this.ErrorMessage = "服务器掉线";
          } else {
            this.ErrorMessage = stReturnData.respMessage;
          }
        } else {
          if (
            stReturnData.data.queryNoType == ApiQueryType.strCarCode ||
            stReturnData.data.queryNoType == ApiQueryType.strCarInfoCode
          ) {
            if (stReturnData.data.queryNoType == ApiQueryType.strCarInfoCode) {
              LogHelper.WriteLog("发车操作查询cp码");
              var carCode = this.DoWithCarInfoCode(scanAreaContent);
              if (carCode == null || carCode == "" || carCode == undefined) {
                this.ErrorMessage =
                  "未查询到车签号，请重扫或直接扫描车签号条码！";
                return;
              } else {
                //车签号
                this.inputModel.input_CarSignNum = carCode;
              }
            } else {
              if (
                stReturnData.data.queryNo.toString().indexOf("CQ") != -1 &&
                stReturnData.data.queryNo.toString().length == 20
              ) {
                this.ErrorMessage = "系统生成的车签，不允许人工录入";
                return;
              }
              //车签号
              this.inputModel.input_CarSignNum = stReturnData.data.queryNo;
            }

            if (this.inputModel.input_CarSignNum.startsWith("CQ")) {
              debugger;
              let response = CarContainerStatus(
                this.inputModel.input_CarSignNum,
                this.globalConfig.LocalMac,
                this.globalConfig.CurrentDeviceType.toString()
              );
              LogHelper.Console(response);
              if (response.status != "1") {
                this.ErrorMessage = response.resMsg;
                this.inputModel.input_CarSignNum = "";
                return;
              }
            }

            let request: any = {};
            request.devMac = this.globalConfig.LocalMac;
            request.devType = "0";
            let _body: any = {};
            _body.queryValue = this.inputModel.input_ScanCode
              .toUpperCase()
              .trim();
            _body.queryType = "27";
            _body.viewType = "";
            _body.extend1 = "";
            _body.extend2 = "";
            _body.extend3 = "";
            request.body = _body;
            let responseStr = faCheGetNextOrgCodeByCQ(JSON.stringify(request));
            let response = JSON.parse(responseStr);
            //测试数据
            // response = {
            //   respcode : "000",
            //   respMessage:"",
            //   data:{
            //     busiDataArray:[
            //       {
            //         endOrgCode:"1",
            //         endOrgName:"1",
            //         extend1:"",
            //         extend2:"",
            //         extend3:""
            //       }
            //     ]
            //     }
            // };
            debugger;
            if (response.respcode != "000") {
              LogHelper.WriteLog(
                "根据车签查询下一网点失败" + response.respMessage
              );
            } else {
              if (!this.inputModel.checked_NextOrgCode) {
                debugger;
                if (response.data.busiDataArray.length > 0) {
                  let list = [];
                  response.data.busiDataArray.forEach((element) => {
                    {
                      list.push({
                        ID: element.endOrgCode,
                        Name: element.endOrgName,
                      });
                    }
                  });
                  if (list.length > 0) {
                    this.inputModel.input_OrgName = list[0].Name;
                  }
                  this.inputModel.options_NextOrg = list;

                  let _nextOrgCode =
                    response.data.busiDataArray[0].endOrgCode;
                  let _lineNo =
                    response.data.busiDataArray[0].extend1;
                  let _lineName =
                    response.data.busiDataArray[0].extend2;
                  if ((_nextOrgCode == null || _nextOrgCode == "") && (_lineNo == null || _lineNo == "")) {

                  } else if (_nextOrgCode != "" && _lineNo != "") {
                    this.inputModel.input_NextOrgCode =
                      response.data.busiDataArray[0].endOrgCode;
                    this.inputModel.input_LineNo =
                      response.data.busiDataArray[0].extend1;
                    this.inputModel.input_LineName =
                      response.data.busiDataArray[0].extend2;
                  }
                }
              }
              LogHelper.WriteLog("根据车签查询下一网点成功");
            }
            if (!this.CheckMainData()) {
              return;
            }
            //车签号
            if (stReturnData.data.queryNoType == ApiQueryType.strCarCode) {
              this.inputModel.input_CarSignNum = stReturnData.data.queryNo;
            } else {
              this.inputModel.input_CarSignNum = scanAreaContent;
            }

            if (
              this.inputModel.input_CarSignNum.toUpperCase().startsWith("AQ")
            ) {
              this.$confirm(
                "车签：" +
                  this.inputModel.input_CarSignNum +
                  ",下一网点为：" +
                  this.inputModel.input_OrgName +
                  ",是否确认发车？",
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                  center: true,
                }
              )
                .then(() => {
                  this.$message({
                    type: "success",
                    message: "确定上传!",
                  });

                  //到车操作
                  if (!this.SendDataToServer()) {
                    return;
                  }

                  if (!this.inputModel.checked_NextOrgCode) {
                    this.inputModel.input_LineNo = "";
                    // this.inputModel.input_LineName = "";
                    this.inputModel.input_NextOrgCode = "";
                    // this.inputModel.input_OrgName = "";
                    // this.inputModel.input_CarSignNum = "";
                  }

                  try {
                    playSuccessSound();
                  } catch (Exception) {
                    this.ErrorMessage = "成功提示音不存在";
                  }
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "取消上传",
                  });
                  this.ErrorMessage = "";
                  this.inputModel.input_CarSignNum = "";
                  this.inputModel.input_LineName = "";
                  this.inputModel.input_LineNo = "";
                  this.inputModel.input_OrgName = "";
                  this.inputModel.input_NextOrgCode = "";
                  this.inputModel.options_NextOrg = [];

                  return;
                });
            } else {
              //到车操作
              if (!this.SendDataToServer()) {
                return;
              }
              debugger;
              if (!this.inputModel.checked_NextOrgCode) {
                this.inputModel.input_LineNo = "";
                // this.inputModel.input_LineName = "";
                this.inputModel.input_NextOrgCode = "";
                // this.inputModel.input_OrgName = "";
                // this.inputModel.input_CarSignNum = "";
              }

              try {
                playSuccessSound();
              } catch (Exception) {
                this.ErrorMessage = "成功提示音不存在";
              }
            }
          } else if (
            stReturnData.data.queryNoType == ApiQueryType.strStationCode
          ) {
            if (this.inputModel.checked_NextOrgCode) {
              return;
            } else {
              let list = [];
              list.push({
                ID: stReturnData.data.queryNo,
                Name: stReturnData.data.nextOrgCodeName,
              });
              if (list.length > 0) {
                this.inputModel.input_OrgName = list[0].Name;
              }
              this.inputModel.options_NextOrg = list;
            }
          } else if (
            stReturnData.data.queryNoType == ApiQueryType.strLineCode
          ) {
            // let stReturnTemp = {};
            // stCodeCheckInput.body.queryType = "1";
            // let strReturnTempStr = checklineFrequencys(
            //   JSON.stringify(stCodeCheckInput)
            // );
            // let strResutnTemp = JSON.parse(strReturnTempStr);
            this.ErrorMessage = stReturnData.respMessage;
            // if (strResutnTemp.respcode != "000") {
            // } else {
            // this.LineNoChange(
            //   strResutnTemp.data.queryNo,
            //   strResutnTemp.data.extend1
            // );
            // }
            debugger;
            this.GetLineDetail(stReturnData.data.queryNo);
            this.LineNoChange(stReturnData.data.queryNo);
          } else {
            this.ErrorMessage = "输入非法的车签";
            try {
              playFailSound();
            } catch (Exception) {
              this.ErrorMessage = "失败提示音不存在";
            }
          }
        }
        if (bReturnState) {
          //tbx_scanArea.Clear();
        }
      } catch (error) {}
    } catch (error) {
      console.log(error.message);
    }
    var el = document.getElementById("input_scancode_id");
    this.selectElementContents(el);
  }
  private GetLineDetail(lineId) {
    let request = {
      devMac: "00-00-00-00-00-00",
      devType: "0",
      body: {
        queryValue: lineId,
        queryType: "16",
        viewType: "1",
        extend1: "1",
        extend2: "10",
        extend3: "",
      },
    };

    let response = JSON.parse(getLineListByPage(JSON.stringify(request)));
    if (
      response != null &&
      response.respcode == "000" &&
      response.data.busiData.records.length > 0
    ) {
      this.inputModel.input_LineName =
        response.data.busiData.records[0].lineName;
      this.inputModel.input_LineNo = response.data.busiData.records[0].lineNo;
    } else {
      this.ErrorMessage = "未查询到线路名称";
    }
  }
  private LineNoChange(id) {
    debugger;
    this.ErrorMessage = "";
    try {
      //对应的线路框里，线路批次，下一网点ChecklineFrequencys(Code_Check_Input stCodeCheckInput, Return_Common stReturn)
      let body: any = {
        queryValue: id, //过滤字符串
        queryType: "21",
        viewType: "1",
        extend1: "", //当前页
        extend2: "", //页大小
        extend3: "", //过滤字段
      };
      let job: any = {
        devMac: "00-00-00-00-00-00",
        devType: "0",
        body: body,
      };
      let resultStr = getOrgCodeListByPage(JSON.stringify(job));
      let result = JSON.parse(resultStr);

      if (result != null) {
        try {
          if (result.data.busiDataArray != null) {
            this.inputModel.options_NextOrg = [];
            result.data.busiDataArray.forEach((element) => {
              this.inputModel.options_NextOrg.push({
                label: element.endOrgName,
                value: element.endOrgCode,
              });
            });
            if (this.inputModel.options_NextOrg.length > 0) {
              this.inputModel.input_OrgName =
                this.inputModel.options_NextOrg[
                  this.inputModel.options_NextOrg.length - 1
                ].label;
              this.inputModel.input_NextOrgCode =
                this.inputModel.options_NextOrg[
                  this.inputModel.options_NextOrg.length - 1
                ].value;
            } else {
              this.inputModel.input_OrgName = "";
              this.inputModel.input_NextOrgCode = "";
            }
          }
        } catch (ex) {
          LogHelper.Error("发车请求下一网点异常:" + ex.toString());
        }
      }
    } catch (ex) {
      LogHelper.WriteLog("选择线路：" + ex);
    }
  }
  private linePrefixRuleIds = [
    "ENT",
    "LTL",
    "FLT",
    "MOT",
    "OTH",
    "WAC",
    "RAL",
    "TPL",
    "RAL",
    "BUS",
    "TFS",
  ]; //合法的线路号前缀集合

  private SendDataToServer() {
    console.log("到车操作");
    console.log(JSON.stringify(this.inputModel));
    let IntReturn = -1;

    IntReturn = this.UploadDataToServer(
      this.inputModel.input_CarSignNum,
      140,
      "NEW"
    );
    if (IntReturn == 1 || IntReturn == 2) {
      //重复就选中
      if (IntReturn == 2) {
        //for (int i = 0; i < dataGridView1.Rows.Count; i++)
        //{
        //    if (dataGridView1.Rows[i].Cells[0].Value.ToString() ==SCANOBJECT["input_CarSignNum"])
        //    {
        //        dataGridView1.Rows[i].Selected = true;
        //        break;
        //    }
        //}
      } else {
        try {
          playFailSound();
        } catch (Exception) {
          this.ErrorMessage = "失败提示音不存在";
        }
      }
      return false;
    }

    this.InsertDataToList();
    this.clearData();

    this.nTotalScanNum++;
    this.totalScanCount = this.nTotalScanNum.toString();

    console.log("发车操作结束");
    return true;
  }
  //发车上传动作
  private UploadDataToServer(strwaybillNo, opCode, strauxOpCode) {
    try {
      debugger;
      let datetimeNow = new Date().valueOf();
      //后续与对应填写，现无法获取数据

      let stResolveCarData: any = {};
      stResolveCarData.devMac = this.globalConfig.LocalMac;
      stResolveCarData.devType = "0";

      let _body: any = {};
      _body.mac = this.globalConfig.LocalMacIPv4;
      _body.aviType = 0;
      _body.trace = 0;
      _body.isFirstTransfer = 1;
      _body.mty = "0100"; //发车
      stResolveCarData.body = _body;

      let _opRecord: any = {};
      _opRecord.auxOpCode = strauxOpCode;
      _opRecord.auxRouteCode = "";

      _opRecord.createOrgCode = this.loginData.orgCode; //创建组织网点，待优化
      _opRecord.createTerminal = this.globalConfig.LocalIPv4;
      //  createTime : (DateTime.Now.ToUniversalTime().Ticks - 621355968000000000) / 10000,//DateTime.Now.ToString("yyyy-MM-dd HH:mm:ss");
      _opRecord.createTime = datetimeNow;
      _opRecord.createUserCode = this.loginData.userCode;
      _opRecord.createUserName = this.loginData.employeeName;
      _opRecord.deviceType = this.globalConfig.CurrentDeviceType.toString();
      _opRecord.expType = 40;
      _opRecord.feeAmt = "";
      _opRecord.feeFlag = 0;
      _opRecord.frequencyNo = null;
      _opRecord.lineNo = this.inputModel.input_LineNo;
      _opRecord.modifyOrgCode = "";
      _opRecord.modifyTerminal = "";
      _opRecord.modifyTime = datetimeNow;

      _opRecord.modifyUserCode = "";
      _opRecord.modifyUserName = "";
      _opRecord.nextOrgCode = this.inputModel.input_NextOrgCode;
      _opRecord.opCode = opCode;
      _opRecord.orgCode = this.loginData.orgCode;
      _opRecord.pkgQty = 1;
      _opRecord.refId = "";
      _opRecord.remark = "";
      _opRecord.routeCode = "";
      _opRecord.status = "";
      _opRecord.transferStatus = 0;
      _opRecord.uploadTime = datetimeNow;
      _opRecord.vehiclePlateNo = "";
      _opRecord.waybillNo = this.inputModel.input_CarSignNum;
      stResolveCarData.body.opRecord = _opRecord;

      let _customData: any = {};
      _customData.backGateSealNo = "";
      _customData.createTimeStr = "";
      _customData.driverNo = "";
      _customData.expCheckResults = "";
      _customData.expOrgDbInfoDto = "";
      _customData.isSupportFrontDb = "";
      _customData.midGateSealNo = "";
      _customData.modifyTimeStr = "";
      _customData.newModule = "";
      _customData.opOrgType = "";
      _customData.otFlag = "0"; //加班车为1 非加班车为0,目前界面已经去除加班车选项框，此处就默认为非加班车
      _customData.sealBreakReason = "";
      _customData.sealStatus = "";
      _customData.snNo = "";
      _customData.traceStatus = "";
      _customData.uploadTimeStr = "";
      _customData.volume = "0";
      _customData.extend1 = "";
      _customData.extend2 = "";
      stResolveCarData.body.opRecord.customData = _customData;

      var strReturnStr = truckOperation(JSON.stringify(stResolveCarData));
      var strReturn = JSON.parse(strReturnStr);
      debugger;
      if (strReturn.respcode != "000") {
        if (
          this.systemConfig.ModeInfo.Mode_Type == ModeType.CrazeScanOutputType
        ) {
          //狂扫失败日志单独记录
          // LogForCrazy.WriteLogAsyn(strwaybillNo + "," + stReturn.respMessage);
          LogHelper.LogForCrazy(strwaybillNo + "," + strReturn.respMessage);
        }
        this.ErrorMessage = strReturn.respMessage;
        if (strReturn.respcode == "101") {
          return 2;
        } else {
          LogHelper.WriteLog("ScanForDepartNew " + strReturn);
          return 1;
        }
      } else {
        ///根据业务网关返回的时间，更新系统时间
        //ToolsOpearation.RefreshLoaclTime(stReturn.data.serverTime);
        try {
          obj_System_Core.refreshLoaclTime(
            strReturn.data.serverTime.toString()
          );
        } catch (error) {
          LogHelper.Error(error);
        }
        LogHelper.WriteLog(strReturn.data.serverTime);
      }
      return 0;
    } catch (ex) {
      LogHelper.Error("ScanForDepart " + "UploadDataToServer crash! " + ex);
      return 1;
    }
  }
  private InsertDataToList() {
    let datetime = dayjs();
    var data: any = {
      strCarCode: this.inputModel.input_CarSignNum,
      strNextOrgCode: this.inputModel.input_OrgName,
      strResolveTime: datetime.format("YYYY-MM-DD HH:mm:ss"),
      state: "上传成功",
      strTip: "",
      index: this.index,
    };
    this.showList.unshift(data);
    this.index++;

    while (this.showList.length > 50) {
      this.showList.pop();
    }
  }
  private clearData() {
    this.inputModel.input_CarSignNum = "";
    this.inputModel.input_LineNo = "";
    this.inputModel.input_LineName = "";
    this.inputModel.input_OrgName = "";
    //comboBoxOrgName.DataSource = list;
    this.inputModel.options_NextOrg = [];
    this.inputModel.input_NextOrgCode = "";
  }
  private CheckMainData() {
    let bIsError = false;
    if (
      this.inputModel.input_LineNo == "" ||
      // this.inputModel.input_OrgName == "" || //2022年7月22日10:06:44  去除该判断
      this.inputModel.input_NextOrgCode == ""
    ) {
      bIsError = true;
    }

    if (bIsError) {
      try {
        playFailSound();
      } catch (Exception) {
        this.ErrorMessage = "失败提示音不存在";
      }
      // this.ErrorMessage = "线路/网点名称/下一网点代码不能为空";//2022年7月22日10:06:44  去除网点名称
      this.ErrorMessage = "线路/下一网点代码不能为空";
      return false;
    }
    return true;
  }
  //根据CP码查询车签
  private DoWithCarInfoCode(carCodeInfo) {
    let carCode = "";
    try {
      let jbody = {
        queryValue: carCodeInfo,
        queryType: "30",
        viewType: "",
        extend1: "1", //1表示上车/封车/发车、2表示下车/到车/解车
        extend2: "",
        extend3: "",
      };

      let request = {
        devMac: this.globalConfig.LocalMac,
        devType: this.globalConfig.CurrentDeviceType.toString(),
        body: jbody,
      };
      let responseStr = getCqNoByCpNo(JSON.stringify(request));
      let response = JSON.parse(responseStr);
      let jresponse = response.data;
      if (jresponse.extend1 != null) {
        carCode = jresponse.extend1;
      }
    } catch (ex) {
      // LogHelper.WriteLog("上车 DoWithCarInfoCode" + ex);
      LogHelper.WriteLog("到车根据CP码查询车签" + ex);
    }
    return carCode;
  }
  //条码规则判断
  private CheckCode(stCodeCheckInput) {
    let _resultStr = toolsRegularCheckCode(JSON.stringify(stCodeCheckInput));
    if (_resultStr != null && _resultStr.length > 0) {
      var _result = JSON.parse(_resultStr);
      return _result;
    } else {
      let responseStr = checkCode(JSON.stringify(stCodeCheckInput));
      if (responseStr != null && responseStr.length > 0) {
        var response = JSON.parse(responseStr);
        return response;
      }
    }

    return null;
  }

  public selectElementContents(el) {
    //失去焦点，获取焦点
    el.blur();
    el.focus();
  }
  private deviceItems: deviceItem[] = [];
}
